import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarRotate = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M9 1.73205L6 3.4641V0L9 1.73205Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 12.9794C7.22717 12.9607 7.45089 12.9292 7.67043 12.8858C7.94132 12.8322 8.11748 12.5692 8.06389 12.2983C8.01029 12.0274 7.74725 11.8512 7.47636 11.9048C7.32016 11.9357 7.16126 11.9594 7 11.9754V12.9794ZM7 2.02466C7.16126 2.04065 7.32016 2.06429 7.47636 2.09519C7.74725 2.14878 8.01029 1.97262 8.06388 1.70173C8.11748 1.43083 7.94132 1.16779 7.67043 1.1142C7.45089 1.07077 7.22717 1.03933 7 1.02057V2.02466ZM9.83405 2.01091C9.60458 1.85729 9.29403 1.91877 9.1404 2.14824C8.98678 2.3777 9.04826 2.68826 9.27773 2.84188C9.8232 3.20706 10.2929 3.67681 10.6581 4.22228C10.8117 4.45174 11.1223 4.51323 11.3518 4.3596C11.5812 4.20598 11.6427 3.89542 11.4891 3.66596C11.0512 3.01187 10.4881 2.44881 9.83405 2.01091ZM12.3858 5.82958C12.3322 5.55869 12.0692 5.38253 11.7983 5.43612C11.5274 5.48971 11.3512 5.75276 11.4048 6.02365C11.4672 6.33902 11.5 6.66544 11.5 7C11.5 7.33457 11.4672 7.66098 11.4048 7.97636C11.3512 8.24725 11.5274 8.5103 11.7983 8.56389C12.0692 8.61748 12.3322 8.44132 12.3858 8.17043C12.4608 7.79148 12.5 7.40008 12.5 7C12.5 6.59993 12.4608 6.20853 12.3858 5.82958ZM11.4891 10.3341C11.6427 10.1046 11.5812 9.79403 11.3518 9.64041C11.1223 9.48678 10.8117 9.54827 10.6581 9.77773C10.2929 10.3232 9.8232 10.7929 9.27773 11.1581C9.04826 11.3118 8.98678 11.6223 9.1404 11.8518C9.29403 12.0812 9.60458 12.1427 9.83405 11.9891C10.4881 11.5512 11.0512 10.9881 11.4891 10.3341Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 1.02054C6.83513 1.00694 6.66838 1 6.5 1C3.18629 1 0.5 3.68629 0.5 7C0.5 10.3137 3.18629 13 6.5 13C6.66838 13 6.83513 12.9931 7 12.9795V11.9753C6.83555 11.9916 6.66875 12 6.5 12C3.73858 12 1.5 9.76142 1.5 7C1.5 4.23858 3.73858 2 6.5 2C6.66875 2 6.83555 2.00836 7 2.02469V1.02054Z"
		})
	]
});
export default SvgToolbarRotate;
